import { findColorKey } from '../../../utils/styles';
import { ColorTypes } from '../../themes/_declarations/colors';
import {
  AccentButton,
  BaseButton,
  PrimaryButton,
  QuaternaryButton,
  SecondaryButton,
  TertiaryButton
} from './styles';
import { ButtonTheme, ButtonType2 } from './types';

export const getButton = (buttonType: ButtonType2): typeof BaseButton => {
  const mapping: any = {
    accent: AccentButton,
    primary: PrimaryButton,
    quaternary: QuaternaryButton,
    secondary: SecondaryButton,
    tertiary: TertiaryButton
  };

  return mapping[buttonType] || PrimaryButton;
};

export const getDefaultIconColor = (
  theme: ButtonTheme,
  disabled?: boolean,
  buttonType: ButtonType2 = 'primary'
): ColorTypes => {
  let colorType: ColorTypes;
  switch (buttonType) {
    case 'accent':
    case 'primary':
      colorType = disabled ? 'dark1Disabled' : 'dark1Default';
      break;
    case 'secondary':
    case 'tertiary':
      colorType = disabled ? 'light2Disabled' : 'light2Default';
      break;

    default:
      colorType = 'dark1Default';
      break;
  }

  return findColorKey(colorType, theme);
};
